import { useEffect, useState } from "react";
import { Star, ExternalLink } from "lucide-react";
import { api } from "@/lib/api";

export default function Reviews() {
  const [reviews, setReviews] = useState(null);

  useEffect(() => {
    api.get("/reviews").then((r) => setReviews(r.data)).catch(() => setReviews([]));
  }, []);

  return (
    <section className="border-b-2 border-black bg-neutral-50" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-20">
        <p className="eyebrow text-neutral-500 mb-4">Word of mouth</p>
        <h2 className="font-display font-black uppercase tracking-tight text-4xl sm:text-5xl mb-12" data-testid="reviews-heading">What customers say</h2>
        {reviews && reviews.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-testid="reviews-grid">
            {reviews.slice(0, 6).map((r) => (
              <figure key={r._id} className="bg-white border-2 border-black p-8 shadow-hard" data-testid={`review-card-${r._id}`}>
                <div className="flex gap-1 mb-4" aria-label={`${r.rating} out of 5 stars`}>
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star key={i} className={`h-5 w-5 ${i < r.rating ? "text-accent fill-accent" : "text-neutral-300"}`} />
                  ))}
                </div>
                <blockquote className="text-neutral-700 leading-relaxed mb-6">“{r.text}”</blockquote>
                <figcaption className="font-display font-bold uppercase tracking-wider text-sm">— {r.author} <span className="text-neutral-400 normal-case font-normal">via Facebook</span></figcaption>
              </figure>
            ))}
          </div>
        ) : (
          <a href="https://www.facebook.com/Applemanrepairs/reviews" target="_blank" rel="noopener noreferrer" data-testid="reviews-facebook-cta"
            className="inline-flex items-center gap-3 border-2 border-black bg-white px-8 py-5 font-display font-bold uppercase tracking-wider shadow-hard brutal-hover">
            Read our customer reviews on Facebook <ExternalLink className="h-5 w-5" />
          </a>
        )}
      </div>
    </section>
  );
}
